//Onepage checkout setup and interactivity, may be separated into 2 plugins eventually

bq.onepage = function(element, options) {
  this.options   = options;
  this.$element  = $(element); //this will be the container element for the html
  this.unsavedBulkChanges = false;
  this.currentGridMode = 'summary';
  this.stickyVisible = false;
  this.submissionDisabled = false;
};

bq.onepage.DEFAULTS = {};

bq.onepage.prototype = {

  init: function() {

    var self = this;

    this.$stickyBar = $('[data-sticky-wrap]');

    bq.debug.log("onepage : init()", this.$form);

    $(window).on('dragstart', function(){
      return false;
    });


    var $bulkEditBubble = $('[data-toggle-bulk-edit]');
    if (this.$stickyBar.length && $bulkEditBubble.length) {
      $(window).on('scroll', bq.helper.debounce(function () {
        var posOfEditBox = $bulkEditBubble.offset().top,
            heightOfEditBox = $bulkEditBubble.height(),
            scrollPos = $(window).scrollTop();

        if (scrollPos > (posOfEditBox + heightOfEditBox)) {
          self.$stickyBar.addClass('animated fadeIn');
          if (!self.stickyVisible && self._stickyBarSummaries[self.currentGridMode]) {
            self._stickyBarSummaries[self.currentGridMode]();
          }
          self.stickyVisible = true;
        } else {
          self.$stickyBar.removeClass('animated fadeIn');
            self.stickyVisible = false;
          }
      }, 20));
    }

    $('.onepage-grid-table').attr('data-grid-mode', 'summary');

    //Radio switching in bulk edit dropdown
    $('input[name="editOpt"]').on('change', function(e){
      var showContainer = $(this).attr('data-show-container');

      $('[data-bulk-container]').hide();
      $('[data-bulk-container="' + showContainer + '"]').show();
    });

    //Horizontal tabs switching in bulk edit
    $(document).on('click', '.onepage-bulk-tab-link', function(e) {
      e.preventDefault();
      var showContainer = $(this).data('show-container');
      $('.onepage-bulk-edit-tab').removeClass('active');
      $(this).closest('.onepage-bulk-edit-tab').addClass('active');
      $('[data-bulk-container]').hide();
      $('[data-bulk-container="' + showContainer + '"]').show();
    });

    if ($('.onepage-bulk-edit-tabs').length) {
      $('.onepage-bulk-edit-area').hide().first().show();
    }

    $(document).on('click', '.onepage-bulk-edit-cancel', function(e) {
        e.preventDefault();
        $('.trigger-bulk-edit').click();
    });

    //Drop down bulk edit box (and trigger default bulk edit mode)
    $(document).on('click', '.trigger-bulk-edit', function(e){
      var $this = $(this);

      if($bulkEditBubble.hasClass('open')) {
        $bulkEditBubble.slideUp().removeClass('open');
	      $this.attr('data-grid-mode-trigger', 'summary');
	      $this.trigger('summaryMode');
        $this.removeClass('onepage-btn-active');
      } else {
        $bulkEditBubble.slideDown().addClass('open');
        $this.removeAttr('data-grid-mode-trigger');
        $($bulkEditBubble.find('[data-grid-mode-trigger]')[0]).click();
        $this.addClass('onepage-btn-active');
        if (!$bulkEditBubble.is(':checked')) {
          $('.trigger-select-all-onepage').click();
        }
        // Hide all opened item notes
        $('.onepage-item-action-area.tab-pane.active').removeClass('active');
        $('.onepage-item-action.active').removeClass('active');
      }
    });

    $('.trigger-sticky-bulk-edit').on('click', function(){
      $('html, body').animate({scrollTop: $bulkEditBubble.offset().top});
    });

    $('.trigger-obo').on('click', function(e){
      var $oboBubble = $('[data-toggle-obo]');

      if($oboBubble.hasClass('open')) {
        $oboBubble.slideUp().removeClass('open');
      } else {
        $oboBubble.slideDown().addClass('open');
      }

      e.preventDefault();
    });

    this.$element.on('bq.onepage.update', function() {
      self._gridSetup();
    });

    //Grid View Switching
    this.$element.on('summaryMode', '.trigger-bulk-edit', this._changeGridMode.bind(this));

    var requestInterval;

    $('[data-bulk-edit-apply]').on('click', function(e) {
      bq.helper.throwEvent('bq.removeNotification', null, {id: 'notification_bq-ui-0'});
      var thiz = this;
      var bulkEditApplyName = thiz.getAttribute('data-bulk-edit-apply');
      self.unsavedBulkChanges = true;
      var intervalIndex = 0;
      if (requestInterval !== undefined) {
        clearInterval(requestInterval);
      }
      if (bulkEditApplyName === 'payment_method') {
        self.triggerTokenex();
      }
      requestInterval = setInterval(function(){
        intervalIndex ++;

        if (intervalIndex > 20) {
          clearInterval(requestInterval);
          console.error('Gateway Timeout');
          return;
        }

        if (bulkEditApplyName !== 'payment_method' || self.canApplyPayments()) {
          var $form = $(thiz).parents('form');
          var formUrl = $form.attr('action');
          var formData = $form.serialize();
          var approvers = $('.approver-updated-data').serialize();
          formData = formData + '&' + approvers;

          var dataToSend = {};
          dataToSend.formData = formData;
          dataToSend.url = formUrl;
          dataToSend.startCallback = function(){
            bq.helper.throwEvent('bq.viewhandler.progressmessage', self.$element, {
              message: 'Applying changes...'
            });
          };
          dataToSend.successCallback = function(){
            $('[data-success-mode="summary"]').removeAttr('disabled');
            !self.options.showBulkEdit && $('.trigger-bulk-edit').click();
            self._updateBudgetAndLimits();
            var $paymentMethods = $('[data-bq="payment-methods"]');
            if ($paymentMethods) {
              $paymentMethods.trigger('bq.paymentMethods.init');
            }

          };
          bq.helper.throwEvent('bq.documentwizard.submitone', self.$element, dataToSend);
          clearInterval(requestInterval);
        }
      } ,500);
      e.preventDefault();
    });

    $('[data-sticky-bulk-edit-apply]').on('click', function() {
      if(self.currentGridMode === 'bulk-edit-shipping') {
        $('[data-bulk-edit-apply="shipping"]').click();
      }
      if(self.currentGridMode === 'bulk-edit-billing') {
        $('[data-bulk-edit-apply="billing"]').click();
      }
      if(self.currentGridMode === 'bulk-edit-accounting') {
        $('[data-bulk-edit-apply="accounting"]').click();
      }
    });

    $('.onepage-edit-expand form').on('bq.documentwizard.form.changed', function(e){
      if (!e.skipStatusChange) {
        $(this).find('[data-bulk-edit-apply]').removeAttr('disabled');
        $('[data-sticky-bulk-edit-apply]').removeAttr('disabled');
      }
      //Todo: how to handle sticky bar when no changes have been made
      self.unsavedBulkChanges = true;
    });

    //DatePicker:: fixes to trigger change event for element and un-block form buttons
    $('.date').each(function() {
      var element = this;
      var $form = $(element).closest("form");
      $(this).on('dp.change', function (e) {//Specialized event
        if (e.date) {
          bq.helper.throwEvent('bq.documentwizard.form.changed', $form, $(element));
        }
      });
    });

    //DatePicker:: fix date auto filling by current date
    $(document).on('date_time_picker_defaults_available', function (event, defaults) {
      defaults.useCurrent = false;
    });

    if (this.options.showBulkEdit) {
      $(document).ready(function() {
        $('.trigger-bulk-edit').removeAttr('data-grid-mode-trigger');
        $('[data-toggle-bulk-edit]').find('[data-grid-mode-trigger]').first().click();
        $('.trigger-bulk-edit').addClass('onepage-btn-active');
        if (!$('[data-toggle-bulk-edit]').is(':checked')) {
          $('.trigger-select-all-onepage').click();
        }
        $('.onepage-item-action-area.tab-pane.active').removeClass('active');
        $('.onepage-item-action.active').removeClass('active');
      });
    }

    this._initApplyAllPaymentButton();

    this._gridSetup();
  },

  triggerTokenex: function() {
      var $paymentMethods = $('[data-bq="payment-methods"]');
      if ($paymentMethods) {
        bq.helper.throwEvent('bq.paymentMethods.preSubmit');
      }
  },

  canApplyPayments: function() {
    var result = true;
    $('[data-bq="payment-creditcards"]:checked').each(function() {
      var $this = $(this);

      // Payment method is not credit card so return
      if (!$this.closest('.row-supplier').find('[data-bq-payment-method-type-radio="credit_card"]').prop('checked')) {
        return;
      }

      var $activeCcHiddenInput = $this.closest('.row-payment-creditcards').find('.payment-method-cc-hidden-cvv');
      if (!$activeCcHiddenInput.val()) {
        result = false;
      }
    });
    return result;
  },

  _initApplyAllPaymentButton: function() {
    var self = this;
    var $formEl = $('[data-bulk-container="bulk_edit_payment_method"] form');
    var $applyBtn = $('[data-bulk-edit-apply="payment_method"]');
    if ($formEl && $formEl.data('bq.hasTokenizationProgressListener') !== true) {
      /**
       * Triggered when user changes Payment Method
       * If anything was changed in payments, we clear all CVV hidden inputs in supplier's row where the change was done
       * If credit card div is active, we disable "Apply all" button and show spinner
       */
      $formEl.on('bq.documentwizard.form.changed', function(e, srcEl) {
        var $srcEl = $(srcEl);
        var $supplierRow = $srcEl.closest('.row-supplier');

        // Clear value of hidden CVV inputs for selected supplier credit cards
        $supplierRow.find('.payment-method-cc-hidden-cvv').each(function(){
          $(this).val(null);
        });
        $formEl.trigger('bq.onepage.payment.applyBtn.updateStatus');
      });

      /**
       * Check if all suppliers' all cards have tokenized CVVs values in respective hidden inputs.
       * If so "Apply all" button is enabled back
       */
      $formEl.on('bq.onepage.payment.applyBtn.updateStatus', function(e) {
        $applyBtn.canEnable = true;

        // If there is a CC selected and there are no credit cards available - disable the Apply To All button
        $('[data-bq-payment-method-type-radio]:checked').each(function() {
          var $this = $(this);
          if ($this.data('bq-payment-method-type-radio') === "credit_card") {
            var showContainer = $this.data('show-container');
            var $container = $('[data-payment-method-container="' + showContainer + '"]');
            var ccRows = $container.find('[data-bq="payment-creditcards"]');

            if (ccRows.length === 0) {
              $applyBtn.canEnable = false;
            }
          }
        });



        if ($applyBtn.canEnable) {
          $applyBtn.attr('disabled', null);
        } else {
          $applyBtn.attr('disabled', 'disabled');
        }
      });

      $formEl.data('bq.hasTokenizationProgressListener', true);
    }
  },

  _changeGridMode: function(e, newMode){
    var $this = $(e.currentTarget),
        oldMode = $('.onepage-grid-table').attr('data-grid-mode'),
        self = this;

    if (newMode === undefined) {
      newMode = $this.attr('data-grid-mode-trigger') || $this.attr('data-success-mode');
    }

    if($this[0].hasAttribute('data-disabled')){
      e.preventDefault();
      return;
    }

    self.currentGridMode = newMode;
    $('[data-grid-mode-trigger]').removeClass('btn-active');

    switch(newMode) {
      case 'summary':
      case 'details':
        $('[data-toggle-bulk-edit]').slideUp().removeClass('open');
        $('.trigger-' + newMode + '-view').addClass('btn-active');
        $('.trigger-bulk-edit, .trigger-summary-view, .trigger-details-view').removeAttr('disabled');
        if(self.stickyVisible) {
          self.$stickyBar.fadeOut();
        }
        break;
      case 'line-edit-shipping':
      case 'line-edit-billing':
      case 'line-edit-accounting':
      case 'line-edit-accounting-mass':
      case 'line-edit-additional':
        $('.trigger-bulk-edit, .trigger-summary-view, .trigger-details-view').attr('disabled', 'disabled');
        self.unsavedBulkChanges = true;
        break;
      case 'bulk-edit-shipping':
      case 'bulk-edit-billing':
      case 'bulk-edit-accounting':
      case 'bulk-edit-receiver':
        $('.trigger-summary-view, .trigger-details-view').attr('disabled', 'disabled');
        break;
    }

    if($this[0].hasAttribute('data-enable-line-edit')) {
      $('[data-disabled]').removeAttr('data-disabled');
    }

    if (typeof( newMode ) != "undefined") {
        $('.onepage-grid-table').removeClass('onepage-' + oldMode + '-mode').addClass('onepage-' + newMode + '-mode').attr('data-grid-mode', newMode);
    }

    if($this.hasClass('trigger-individual-mode')) {
      e.stopPropagation();
    }

  },

  _validInputs: function() {
    if($('.has-error').length) {
      return false;
    }
    return true;
  },

  _disableSubmit: function() {
    $('#submit_button').attr('disabled', 'disabled');
  },

  _enableSubmit: function() {
    if (this.submissionDisabled === false) {
      $('#submit_button').removeAttr('disabled');
    }
  },

  _gridSetup: function() {
    var self = this;

    function validateInput($elements) {
      $elements.filter('.required-entry').each(function () {
        const $this = $(this);
        const $parent = $this.parent();
        if ($this.val().length === 0) {
          self._disableSubmit();
          $parent.addClass('has-error');
        } else {
          $parent.removeClass('has-error');
        }
      });
    }

    if ($('#disable-submission-bar').length) {
      this.submissionDisabled = jQuery('#disable-submission-bar').attr('data-has-errors') === '1';
      if (this.submissionDisabled) {
        this._disableSubmit();
      }
    }

    this.$element.off('click', '.document-form-save');
    this.$element.on('click', '.document-form-save', function(e) {
      e.preventDefault();
      var $this = $(this);
      var formId = $this.attr('data-form-id');
      var $form = $('.document-form-row[data-form-id="' + formId + '"] form');
      var elements = $form.find('input,select');
      validateInput(elements);
      if (!self._validInputs()) {
        return false;
      }

      var dataToSend = {};

      self._enableSubmit();
      bq.helper.throwEvent('bq.removeNotification', null, {id: 'notification_bq-ui-0'});
      dataToSend.formData = elements.serialize();
      dataToSend.url = $form.prop('action');
      dataToSend.startCallback = function() {
        bq.helper.throwEvent('bq.viewhandler.progressmessage', self.$element, {
          message: bq.messages.global.loadingGeneral
        });
      };
      bq.helper.throwEvent('bq.documentwizard.submitone', self.$element, dataToSend);
    });

    this.$element.off('click', '#button_title_phone');
    this.$element.on('click', '#button_title_phone', function(e) {
      e.preventDefault();
      var $this = $(this),
        dataToSend = {},
        elements = $($this.parents('form')[0]).find('input');
      validateInput(elements);
      if (!self._validInputs()) {
        return false;
      }
      self._enableSubmit();
      bq.helper.throwEvent('bq.removeNotification', null, {id: 'notification_bq-ui-0'});
      dataToSend.formData = elements.serialize();
      dataToSend.url = $($this.parents('form')[0]).prop('action');
      dataToSend.startCallback = function() {
        bq.helper.throwEvent('bq.viewhandler.progressmessage', self.$element, {
          message: bq.messages.global.loadingGeneral
        });
      };
      bq.helper.throwEvent('bq.documentwizard.submitone', self.$element, dataToSend);
    });

    $('#order_name, #customer_telephone, .document-form-input, [name="approver_note"]').on('keydown', function(e){
      if (e.keyCode == 13) {
        return false;
      }
      var $this = $(this);
      $this.parent().find('.fa').remove();
      self._enableSubmit();

      validateInput($this);

      if(!self._validInputs()){
        self._disableSubmit();
      }
    }).each(function() {
      validateInput($(this));
    });

    //To prevent compounding of events listeners during multiple initializations
    $('.onepage-item-action').off('shown.bs.tab');

    //Bootstrap tabs modification
    $('.onepage-item-action').on('shown.bs.tab', function(e) {
      if($(e.target).hasClass('active')) {
        $(e.target).removeClass('active');
        $(e.target).parent().parent().find('.onepage-item-action-area').removeClass('active');
        return;
      }
      $(e.target).parent().find('.onepage-item-action').removeClass('active');
      $(e.target).addClass('active');
    });

    //Line level enabling/disabling of Save button
    $('[data-form-container]')
      .on('bq.documentwizard.form.changed', function(){
        bq.helper.throwEvent('bq.loadingbutton.stop', $(this).find('[data-line-action-save]'));
        if ($(this).find('[data-line-action-cancel]')) {
            $(this).find('[data-line-action-cancel]').removeAttr('disabled').show();
        }
        $(this).addClass('unsaved-line-action');
      })
      .on('bq.documentwizard.form.unchanged', function(){
        $(this).removeClass('unsaved-line-action');
      });

    //merged all ajax button actions here
    this.$element.off('click', '[data-ajax-button]');
    this.$element.on('click', '[data-ajax-button]', function(e) {
      if (bq.helper.checkInitiator('newrelic')) {
        return;
      }

      bq.helper.throwEvent('bq.removeNotification', null, {id: 'notification_bq-ui-0'});
      var $this = $(this),
          vhMessage = $this.data('view-handler-message');
      var dataContainer = $this.data('container');

      if (!$this.data('ajax-url') || $this[0].hasAttribute('data-disabled')) {
        e.preventDefault();
        return;
      }

      if ($this.data('cancel-edit') === undefined && dataContainer != null) {
        var $gridMultiLocation = $(dataContainer).find('.onepage-grid-multi-location').first();

        if ($gridMultiLocation.length > 0) {
          self._onSaveMultiLocation($gridMultiLocation, e);
          e.preventDefault();

          return;
        }
      }

      if ($this.data('check-for-errors')) {
        if(self._checkForErrorsAndUnsaved()) {
          bq.helper.smoothScroll(self.$element.find('.has-error, .unsaved-line-action')[0]);
          return false;
        }
      }

      $('[data-toggle-bulk-edit]').slideUp().removeClass('open');
      $('.trigger-bulk-edit').removeClass('onepage-btn-active');
      $('[data-bq="approvers"]').trigger('bq.approvers.updated');

      var dataToSend = {};
      dataToSend.formData = {};
      dataToSend.url = (self.currentGridMode == 'line-edit-commodity' && !$this.data('cancel-edit'))
        ? $this.data('commodity-save-url')
        : $this.data('ajax-url');

      if (typeof( dataContainer ) != "undefined") {
        var $elements = $(dataContainer).find('input, select, textarea');
        if (self.currentGridMode == 'line-edit-accounting') {
          dataToSend.formData = {
            data_compressed: btoa($elements.serialize())
          };
        } else {
          dataToSend.formData = $elements.serialize();
        }
      }

      if($this.data('line-action-save')) {
        bq.helper.throwEvent('bq.documentwizard.lineactionsave', self.$element, {
          form: $this.parents('[data-form-container]'),
          formData: dataToSend.formData,
          url: $this.data('ajax-url'),
          clickedEl: $this,
          successCallback: function() {
            self._updateBudgetAndLimits();
            bq.helper.throwEvent('advanced.upload.block.reload');
          }
        });
      } else {
        dataToSend.startCallback = function(){
          bq.helper.throwEvent('bq.viewhandler.progressmessage', self.$element, {
            message: vhMessage
          });
        };

        if($this.attr('data-success-mode')) {
          dataToSend.successCallback = function(){
            self._changeGridMode(e);
            self._updateBudgetAndLimits();
          };
        } else {
          dataToSend.successCallback = function(){
            self._updateBudgetAndLimits();
            if ($this.data('accounting-item-id')) {
              bq.helper.smoothScroll($('[data-item-id="' + $this.data('accounting-item-id') + '"]')[0]);
            }
          };
        }

        if ($this.attr('data-error-mode')) {
          let oldMode = ($this.attr('data-error-mode') === 'keep-old-grid-mode')
              ? $('.onepage-grid-table').attr('data-grid-mode')
              : undefined;
          dataToSend.errorsCallback = function() {
            self._changeGridMode(e, oldMode);
          };
        } else if ($('#payment-provider-instructions:not(:empty)').length === 1) {
          dataToSend.errorsCallback = function() {
              bq.helper.smoothScroll($('#payment-provider-instructions')[0]);
          };
        }

        bq.helper.throwEvent('bq.documentwizard.submitone', self.$element, dataToSend);
      }

      self._changeGridMode(e);
      e.preventDefault();
    });

    $('[data-ajax-multi-location]').off('click').on('click', self._bindGridMultiLocationObserver.bind(self));

    //approvers serialization
    $('[data-bq="approvers"]').on('bq.approvers.updated', function(e) {
      $('[data-bq="approvers"]').trigger('bq.approvers.save', '.approver-updated-data');
    });
    $('[data-bq="approvers"]').on('bq.approvers.save.after', function(e) {
      self._enableSubmit();
    });

    //hide block on "Cancel" button clicked
    $('[data-line-action-cancel]').on('click', function(e) {
      var $dataContainer = $($(this).data('container'));
      if (typeof( $dataContainer ) != "undefined") {
        $dataContainer
            .closest(".checkoutlite-wrapper").find('.active').removeClass('active');
        $dataContainer.find('input, textarea, select').each(function () {
          if($(this).data('initialValue')) {
            $(this)[0].value = $(this).data('initialValue');
          } else {
            $(this).val('');
          }

          $(this).parents('.form-group').removeClass('has-error');
          $(this).trigger('keyup');
        });
      }

      e.preventDefault();
    });

    this._checkBoxesInit();
  },

  _bindGridMultiLocationObserver: function(e) {
      e.preventDefault();
      var self = this;
      var $this = $(e.target);

      $('[data-toggle-bulk-edit]').slideUp().removeClass('open');
      $('.trigger-bulk-edit').removeClass('onepage-btn-active');

      bq.helper.throwEvent('bq.viewhandler.progressmessage', self.$element, {
          message: $this.data('view-handler-message'),
      });

      $.ajax({
          type: 'post',
          url: $this.data('ajax-url'),
          dataType: 'json',
          success: function(response) {
              if (!response || !response.html) {
                  console.warn('Response is invalid.', response);

                  return;
              }

              try{
                if (response.updates) {
                  response.updates.forEach(function (obj) {
                    $(obj.selector).html(obj.content);
                  });
                }
              }catch (exception) {}

              var $ajaxContainer = $($this.data('ajax-container'));

              $ajaxContainer.html(response.html);
              self._changeGridMode(e);
              watchMainControls($ajaxContainer);
          },
          complete: function() {
              bq.helper.throwEvent('bq.viewhandler.stop', $('[data-view-handler]'));
          },
      });

      function watchMainControls($container) {
          $container.find('[data-multi-location-main-form-control]').each(function() {
              var $control = $(this);
              var $controlName = $control.data('multi-location-main-form-control');
              var $applyToAllButton = $('[data-multi-location-applyall="' + $controlName + '"]').first();

              if ($applyToAllButton.length === 0) {
                  return;
              }

              $applyToAllButton.on('click', function() {
                  var item = $('[name="' + $controlName + '"][data-multi-location-id]');

                  item.prop('checked', true);
                  item.val($control.val());
              });
          });
          $container.find('input[type="checkbox"]').on('click', function() {
              var self = $(this);
              if (self.is(':checked')) {
                  self.val(1);
              } else {
                  self.val(0);
              }
          });
      }
  },

  _onSaveMultiLocation: function($container, event) {
    var self = this;
    var submitUrl = $(event.target).data('ajax-url');
    var formData = new FormData();
    formData.append('form_key', $container.find('[name=form_key]').val());
    formData.append('item_id', $container.find('[name=item_id]').val());

    $container.find('td [data-multi-location-id]').each(function(i, control) {
      var $control = $(control);
      var locationId = $control.data('multi-location-id');
      var controlName = $control.attr('name');
      var value = $control.val();

      formData.append('items[locations][' + locationId + '][' + controlName + ']', value);
    });

    bq.helper.throwEvent('bq.viewhandler.progressmessage', this.$element, {
      message: bq.messages.global.loadingGeneral,
    });

    $.ajax({
      url: submitUrl,
      type: 'POST',
      data: formData,
      cache: false,
      processData: false,
      contentType: false,
      success: function(response) {
        var data = JSON.parse(response);

        if ('forward' in data) {
          setLocation(data.forward);
          return;
        }

        if ('errors' in data && data.errors.length > 0) {
          data.errors.forEach(function(obj, index) {
            bq.helper.throwEvent('bq.notification', $(document), {
              id: 'notification_bq-ui-' + index,
              text: obj.message,
              type: 'error'
            });
            if ('updates' in obj && Array.isArray(obj.updates)) {
              obj.updates.forEach(function(i) {
                $(i.selector).html(i.content);
              });
            }
          });

          return;
        }

        if (!('updates' in data) || !Array.isArray(data.updates)) {
          console.error('Received invalid response.');
          return;
        }

        data.updates.forEach(function(i) {
          $(i.selector).html(i.content);
        });

        if ($(event.target).context.id == 'bqat-btnSaveLineChanges') {
          $("#field_as_billing").html('');
        }

        self._updateBudgetAndLimits();
        self._changeGridMode(event);
        $('[data-ajax-multi-location]').off('click').on('click', self._bindGridMultiLocationObserver.bind(self));
      },
      complete: function() {
        bq.helper.throwEvent('bq.viewhandler.stop', $('[data-view-handler]'));
      },
    });
  },

  _checkBoxesInit: function() {
    $('.trigger-select-all-onepage').on('click', function(){
      var $this = $(this),
        ind = $this.index() + 1,
        isChecked = $this.is(':checked'),
        $checkBoxCollection = $this.parents('table').find('tr td:nth-child(' + ind + ') ' +
          'input[type="checkbox"]');

      if(isChecked) {
        $checkBoxCollection.prop('checked', true);
      } else {
        $checkBoxCollection.prop('checked', false);
      }

      $checkBoxCollection.each(function(){
        $(this).off('click');
        $(this).on('click', function(){
          if(!$(this).is(':checked')) {
            $this.prop('checked', false);
          }
        });
      });
    });
  },

  //Get short summaries for sticky bar
  _stickyBarSummaries: {
    'bulk-edit-shipping': function(){
      var addressFavName = $('.onepage-bulk-edit-area #address-block-long-shipping address strong').text().trim(),
        deliverTo = $('#deliver_to').val(),
        needByDate = $('#need_by_date').val(),
        summString = '';

      if(addressFavName) {
        summString += '<span class="onepage-item-detail-field">' + addressFavName + '</span> ';
      }

      if(deliverTo) {
        summString += 'Deliver to: ' + deliverTo + ' ';
      }

      if(needByDate) {
        summString += 'Need by: ' + needByDate;
      }

      if(!summString){
        summString = 'Please add shipping changes.';
      }

      $('[data-sticky-title]').text('Bulk Edit Shipping');
      $('[data-sticky-summary]').html(summString);
    },
    'bulk-edit-billing': function(){
      var addressFavName = $('.onepage-bulk-edit-area #address-block-long-billing address strong').text().trim(),
        summString = '';

      if(addressFavName) {
        summString += '<span class="onepage-item-detail-field">' + addressFavName + '</span> ';
      }

      if(!summString){
        summString = 'Please add billing changes.';
      }

      $('[data-sticky-title]').text('Bulk Edit Billing');
      $('[data-sticky-summary]').html(summString);
    },
    'bulk-edit-accounting': function(){
      var valuesObj = null,
          noneSelected = 'None selected',
          summString = '';

      if($('[data-bulk-container] .accounting-data .accounting-block')[0]) {
        valuesObj = $($('[data-bulk-container] .accounting-data .accounting-block')[0]).data().values;

        if(valuesObj['Business Unit']){
          summString += '<span class="onepage-item-detail-field">Business Unit</span> ' + valuesObj['Business Unit'];
        }
        if(valuesObj['Cost Center']){
          summString += ' <span class="onepage-item-detail-field">Cost Center</span> ' + valuesObj['Cost Center'];
        }
      }

      if(!summString){
        summString = noneSelected;
      }

      $('[data-sticky-title]').text('Bulk Edit Accounting');
      $('[data-sticky-summary]').html(summString);
    }

  },

  _checkForErrorsAndUnsaved: function(){
    if(this.$element.find('.has-error, .unsaved-line-action').length){
      return true;
    }
    return false;
  },

  _updateBudgetAndLimits: function() {
    if ($('[data-bq="accounting-budget"]').length) {
      bq.updateAccountingBudgets();
    }

    if ($('[data-bq="product-limit"]').length) {
      bq.updateProductLimits();
    }
  }

};

// onepage PLUGIN DEFINITION
// =======================

var onepageold = $.fn.onepage;

$.fn.onepage = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.onepage');
    var options = $.extend({}, bq.onepage.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.onepage', (data = new bq.onepage(this, options))); }
    data.init();
  });
};

$.fn.onepage.Constructor = bq.onepage;

// onepage NO CONFLICT
// =================

$.fn.onepage.noConflict = function () {
  $.fn.onepage = onepageold;
  return this;
};

// onepage DATA-API
// ==============

bq.onepageInit = function() {
  $('[data-onepage-init]').each(function () {
    var el = $(this);
    if(el.data('bq.onepage')) { return; }
    el.onepage(el.data());
  });
};

bq.init.push(bq.onepageInit);
